<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import { MembershipActionTypes, useMembershipListStore } from '@/modules/setting/stores/membership.list.store.ts'
import MembershipDetail from '@/modules/setting/views/MembershipDetail.vue'


const router = useRouter()
const membershipListStore = useMembershipListStore()


const pageTabs = computed(() => {
  return membershipListStore.tabs
})
const displayTabContent = computed(() => {
  return membershipListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return membershipListStore.tableConfig
})
const filter = computed(() => {
  return membershipListStore.filter
})
const loading = computed(() => {
  return membershipListStore.action_type == MembershipActionTypes.FETCHING
})
const page = computed(() => {
  return membershipListStore.page
})
const pageSize = computed(() => {
  return membershipListStore.pageSize
})
const dataSource = computed(() => {
  return membershipListStore.data
})

const handleChangeTab = (tab: any) => {

  membershipListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  membershipListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  membershipListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  membershipListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  membershipListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  membershipListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  membershipListStore.newTab({id: item.id, label: `#${item.id} - ${item.name}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  membershipListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await membershipListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> membershipListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  if(membershipListStore.action_type === MembershipActionTypes.PENDING) requestFetchAccountList()
})
</script>

<template>
  <dashboard-layout currentRoute="system/memberships" page-title="Danh sách các gói hội viên" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
      />

      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        primaryField="code"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="membershipListStore.toggleColumnVisibility"
        @on-sort="handleSort"
        :row-action-buttons="[
          { action: handleRowDblClick, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone' }
        ]"
        :buttons="[
                {
                  label: 'Thêm gói',
                  icon: 'gridicons:create',
                  class: 'btn bg-primary bg-hover-primary text-white',
                  action: () => {
                    router.push({ name: 'membership-plan-create' })
                  },
                },
                {
                  label: 'Xoá gói đang chọn',
                  icon: 'tabler:trash',
                  class: 'btn btn-secondary bg-hover-secondary',
                  action: () => {},
                },
              ]"
      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <MembershipDetail :id="tab.id" :key="tab.id" action="update"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
